// AUTO-GENERATED — DO NOT EDIT.
// Source: YAML frontmatter in src/content/blog/posts/*.mdx
// Regenerate: npm run build:shared

export interface RawBlogPostEntry {
  slug: string;
  title: string;
  description: string;
  excerpt: string;
  publishDate: string;
  updatedDate: string;
  reviewedDate: string;
  authorName: string;
  authorType: string;
  authorRole: string;
  authorCredentials: string;
  reviewerName: string;
  reviewerType: string;
  reviewerRole: string;
  reviewerCredentials: string;
  expertiseAreas: string[];
  primaryCtaPath: string;
  primaryCtaLabel: string;
  primaryCtaDescription: string;
  readingTimeMinutes: number;
  category: string;
  audience: string;
  tags: string[];
  contentFileName: string;
}

export const RAW_BLOG_POST_ENTRIES: RawBlogPostEntry[] = [
  {
    "slug": "direct-school-admission-secondary-guide",
    "title": "Direct School Admission (DSA-Sec): A Complete Guide for Parents",
    "description": "A plain-English guide to DSA-Sec — what it is, the talent areas, the application timeline, how selection works, and how a DSA place is actually secured against a Posting Group minimum rather than a school's cut-off point.",
    "excerpt": "DSA runs alongside the PSLE posting system most families spend a year preparing for, and most parents only half-understand the trade it asks for. Here is the whole mechanism.",
    "publishDate": "2026-04-20",
    "updatedDate": "2026-04-20",
    "reviewedDate": "2026-04-20",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for accuracy against current MOE DSA-Sec guidance and the 2026 DSA-Sec exercise press release",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against MOE's DSA-Sec eligibility, selection, and preferences pages, and MOE's Secondary 1 Posting Exercise guidance",
    "expertiseAreas": [
      "Singapore Education",
      "Secondary Math",
      "Parent Guidance"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Talk to us about your child's secondary options",
    "primaryCtaDescription": "Speak with our team about DSA, secondary Math, and how to prepare for the transition either way.",
    "readingTimeMinutes": 13,
    "category": "Secondary Math",
    "audience": "parents-and-students",
    "tags": [
      "dsa",
      "dsa-sec",
      "secondary-admission",
      "singapore-education",
      "psle",
      "moe"
    ],
    "contentFileName": "direct-school-admission-secondary-guide.mdx"
  },
  {
    "slug": "exercise-and-maths-performance",
    "title": "Exercise and Maths Performance: The Connection Singapore Parents Are Missing",
    "description": "The research on physical activity and mathematical reasoning is substantial and almost completely ignored in Singapore. Here is exactly what kind of exercise, how much, and when — backed by neuroscience.",
    "excerpt": "The families who add the most desk hours are often the ones suppressing their child's ability to use that desk time effectively.",
    "publishDate": "2025-06-14",
    "updatedDate": "2025-06-14",
    "reviewedDate": "2025-06-14",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for alignment with exercise-cognition research and Singapore academic context",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against neuroscience literature on exercise and executive function in children",
    "expertiseAreas": [
      "Math Learning",
      "Learning Science",
      "Primary Math",
      "Secondary Math"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Talk to us about your child",
    "primaryCtaDescription": "Speak with our team about how we approach learning conditions alongside content teaching.",
    "readingTimeMinutes": 17,
    "category": "Learning & Mindset",
    "audience": "parents-and-students",
    "tags": [
      "math-learning",
      "learning-science",
      "psle",
      "o-level",
      "study-skills",
      "singapore-tuition"
    ],
    "contentFileName": "exercise-and-maths-performance.mdx"
  },
  {
    "slug": "full-subject-based-banding-explained",
    "title": "The End of Streaming: A Parent's Guide to Full Subject-Based Banding",
    "description": "A complete guide to Full Subject-Based Banding in Singapore — what replaced streaming, how Posting Groups and G1/G2/G3 subject bands work, the new SEC national exam, and what it all means for your child.",
    "excerpt": "The secondary system your child is in is not the one you went through. Streaming is gone, replaced by subject bands and a new national certificate. Here is the whole new architecture, explained.",
    "publishDate": "2026-06-09",
    "updatedDate": "2026-06-09",
    "reviewedDate": "2026-06-09",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for accuracy against current MOE Full Subject-Based Banding and SEAB SEC documentation",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against MOE Full SBB pages, MOE press releases, and SEAB's Secondary Education Certificate documentation",
    "expertiseAreas": [
      "Secondary Math",
      "Subject-Based Banding",
      "Singapore Education",
      "Parent Guidance"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Talk to us about your child",
    "primaryCtaDescription": "Speak with our team about which Math band suits your child and how to prepare for it.",
    "readingTimeMinutes": 11,
    "category": "Secondary Math",
    "audience": "parents-and-students",
    "tags": [
      "subject-based-banding",
      "g1-g2-g3",
      "streaming",
      "secondary-math",
      "singapore-education",
      "moe"
    ],
    "contentFileName": "full-subject-based-banding-explained.mdx"
  },
  {
    "slug": "how-online-math-tuition-actually-works",
    "title": "How Online Math Tuition Actually Works — A Walkthrough for Parents",
    "description": "A practical walkthrough of how a live online math tuition class actually runs from start to finish — the tech setup, the 1.5-hour structure, the tools used, the practice between lessons, and what parents see week to week.",
    "excerpt": "Most parents have never sat in on an online math class. Here is what actually happens, minute by minute, and what to look for if you are evaluating one.",
    "publishDate": "2025-11-01",
    "updatedDate": "2025-11-01",
    "reviewedDate": "2025-11-01",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for online live-class operations and Singapore tuition relevance",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against current online live-class structure, between-lesson practice flow, and parent reporting patterns",
    "expertiseAreas": [
      "Online Learning",
      "Math Learning",
      "Singapore Tuition",
      "Parent Guidance"
    ],
    "primaryCtaPath": "/online-math-tuition",
    "primaryCtaLabel": "See how DeepThink runs online math tuition",
    "primaryCtaDescription": "Read the pillar page on how DeepThink delivers live online math tuition for Singapore primary and secondary students.",
    "readingTimeMinutes": 8,
    "category": "Choosing Math Tuition",
    "audience": "parents-and-students",
    "tags": [
      "online-tuition",
      "online-learning",
      "singapore-tuition",
      "math-tuition",
      "parent-guidance"
    ],
    "contentFileName": "how-online-math-tuition-actually-works.mdx"
  },
  {
    "slug": "how-psle-al-scoring-and-secondary-posting-work",
    "title": "How PSLE AL Scoring and Secondary 1 Posting Actually Work",
    "description": "A complete, plain-English guide to the PSLE Achievement Level (AL) scoring system and Secondary 1 posting — how the score is built, how cut-off points work, how ties are broken, Posting Groups, affiliation, and DSA.",
    "excerpt": "Every P6 family fixates on the PSLE Score, but few understand how it is actually built or how it turns into a secondary school place. Here is the whole mechanism, accurately.",
    "publishDate": "2026-05-20",
    "updatedDate": "2026-05-20",
    "reviewedDate": "2026-05-20",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for accuracy against the current MOE PSLE scoring and Secondary 1 posting documentation",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against MOE PSLE-FSBB scoring pages, the S1 Posting Exercise guidance, and SEAB documentation",
    "expertiseAreas": [
      "Primary Math",
      "PSLE",
      "Singapore Education",
      "Parent Guidance"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Talk to us about your child's PSLE",
    "primaryCtaDescription": "Speak with our team about PSLE Math preparation and how the AL system should shape your child's revision.",
    "readingTimeMinutes": 12,
    "category": "Primary Math",
    "audience": "parents-and-students",
    "tags": [
      "psle",
      "al-scoring",
      "secondary-posting",
      "primary-math",
      "singapore-education",
      "moe"
    ],
    "contentFileName": "how-psle-al-scoring-and-secondary-posting-work.mdx"
  },
  {
    "slug": "how-to-choose-o-level-math-tuition-without-wasting-money",
    "title": "How to Choose O-Level Math Tuition Without Wasting Money",
    "description": "An honest guide to choosing O-Level Math tuition in Singapore — what to look for, what to watch out for, and how to make sure the money actually goes toward your child's learning.",
    "excerpt": "What actually separates tuition that works from tuition that just keeps your child busy — and how to tell the difference before you commit.",
    "publishDate": "2025-12-31",
    "updatedDate": "2025-12-31",
    "reviewedDate": "2025-12-31",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for O-Level E-Math and A-Math programme fit",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against current Singapore Secondary Math assessment demands",
    "expertiseAreas": [
      "O-Level Math",
      "Tuition Selection",
      "Exam Preparation"
    ],
    "primaryCtaPath": "/o-level",
    "primaryCtaLabel": "See O-Level Math tuition options",
    "primaryCtaDescription": "Review our online small-group O-Level classes for E-Math and A-Math support.",
    "readingTimeMinutes": 17,
    "category": "Choosing Math Tuition",
    "audience": "parents-and-students",
    "tags": [
      "o-level",
      "math-tuition",
      "secondary-math",
      "a-math",
      "e-math"
    ],
    "contentFileName": "how-to-choose-o-level-math-tuition-without-wasting-money.mdx"
  },
  {
    "slug": "how-to-tell-if-your-child-is-paying-attention-in-an-online-class",
    "title": "How to Tell If Your Child Is Actually Paying Attention in an Online Class",
    "description": "The signs of genuine attention versus quiet disengagement in online tuition are specific and learnable — here is what to look for and what to do about it.",
    "excerpt": "Your child is seated at the desk. The laptop is open. The lesson is running. But are they actually there?",
    "publishDate": "2025-08-13",
    "updatedDate": "2025-08-13",
    "reviewedDate": "2025-08-13",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for online tuition and home-based learning relevance",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against Singapore online tuition and HBL learning patterns",
    "expertiseAreas": [
      "Online Learning",
      "Study Skills",
      "Parent Guidance"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Talk to us about your child",
    "primaryCtaDescription": "Speak with our team about how we structure online sessions to keep students genuinely engaged.",
    "readingTimeMinutes": 11,
    "category": "Choosing Math Tuition",
    "audience": "parents-and-students",
    "tags": [
      "online-tuition",
      "online-learning",
      "attention",
      "home-based-learning",
      "singapore-tuition"
    ],
    "contentFileName": "how-to-tell-if-your-child-is-paying-attention-in-an-online-class.mdx"
  },
  {
    "slug": "integrated-programme-explained",
    "title": "Singapore's Integrated Programme: How It Works and Who It Is For",
    "description": "A guide to Singapore's six-year Integrated Programme: which schools offer it, the qualifications they lead to, how PSLE and DSA-Sec entry work, and which students may benefit from choosing IP.",
    "excerpt": "IP students do not take a national examination at Secondary 4. This gives schools more time for a broader curriculum, but students receive no national examination result before their final qualification in Year 6.",
    "publishDate": "2026-05-08",
    "updatedDate": "2026-09-05",
    "reviewedDate": "2026-08-13",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for accuracy against current MOE Integrated Programme guidance and individual IP school pages",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against MOE's Integrated Programme and DSA-Sec pages, MOE-sourced school records cross-referenced with DeepThink's own school directory and spot-checked via MOE SchoolFinder, and official pages from Anglo-Chinese School (Independent), St. Joseph's Institution, Raffles Girls' School, Singapore Chinese Girls' School, and Eunoia Junior College",
    "expertiseAreas": [
      "Singapore Education",
      "Secondary Math",
      "Parent Guidance"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Talk to us about your child's IP Math",
    "primaryCtaDescription": "Ask how our tutors match live IP Mathematics classes to your child's school scheme of work.",
    "readingTimeMinutes": 11,
    "category": "Secondary Math",
    "audience": "parents-and-students",
    "tags": [
      "integrated-programme",
      "ip",
      "secondary-admission",
      "singapore-education",
      "psle",
      "moe"
    ],
    "contentFileName": "integrated-programme-explained.mdx"
  },
  {
    "slug": "ip-schools-in-singapore",
    "title": "IP Schools in Singapore: All 17 and How to Shortlist Them",
    "description": "Compare all 17 Integrated Programme schools by their Years 5–6 destination and final qualification, then build a realistic shortlist for Secondary 1 posting or DSA-Sec.",
    "excerpt": "Singapore has 17 IP schools. Start with where each programme leads, then compare admission route, student fit, school experience and the practical six-year commitment.",
    "publishDate": "2026-08-13",
    "updatedDate": "2026-09-05",
    "reviewedDate": "2026-09-05",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Compiled from current MOE admissions guidance and the schools' official Integrated Programme pages",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "School list, Years 5–6 destinations and qualifications rechecked against current school programme and admissions pages on 5 September 2026",
    "expertiseAreas": [
      "Singapore Education",
      "Secondary Math",
      "Parent Guidance"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Ask us about your school's IP Math",
    "primaryCtaDescription": "Tell us which IP school your child is considering and we will explain how its Math pathway differs.",
    "readingTimeMinutes": 7,
    "category": "Secondary Math",
    "audience": "parents-and-students",
    "tags": [
      "integrated-programme",
      "ip",
      "secondary-admission",
      "singapore-education",
      "ib",
      "secondary-math"
    ],
    "contentFileName": "ip-schools-in-singapore.mdx"
  },
  {
    "slug": "is-a-math-required-for-polytechnic",
    "title": "A-Math for Polytechnic: Not Generally Required, but Still Useful",
    "description": "A-Math is not a general polytechnic entry requirement, but it can help with some aggregates and math-heavy diplomas. Check what your target course requires before deciding.",
    "excerpt": "E-Math alone can satisfy the Mathematics minimum for current courses such as SP Common Engineering. Check the exact requirement, aggregate and first-year modules before keeping or dropping A-Math.",
    "publishDate": "2026-08-13",
    "updatedDate": "2026-09-05",
    "reviewedDate": "2026-09-05",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed against current MOE admissions guidance and Singapore Polytechnic's 2026 entry requirements, aggregate rules and module descriptions",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Admission claims and ELR2B2 arithmetic rechecked against official sources on 5 September 2026",
    "expertiseAreas": [
      "A-Math",
      "Secondary Math",
      "Singapore Education",
      "Parent Guidance"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Talk to us about your Math pathway",
    "primaryCtaDescription": "Discuss how E-Math, A-Math and a target diploma fit your current results and workload.",
    "readingTimeMinutes": 7,
    "category": "Secondary Math",
    "audience": "parents-and-students",
    "tags": [
      "a-math",
      "polytechnic",
      "elr2b2",
      "o-level",
      "moe",
      "secondary-math"
    ],
    "contentFileName": "is-a-math-required-for-polytechnic.mdx"
  },
  {
    "slug": "is-online-math-tuition-effective-for-psle",
    "title": "Is Online Math Tuition Effective for PSLE? A Careful Look at the Evidence",
    "description": "An honest review of whether online math tuition can be effective for PSLE preparation in Singapore — what the research on synchronous online instruction shows, what PSLE specifically rewards, and a five-question framework parents can use to evaluate any online programme.",
    "excerpt": "The honest answer is \"yes, when the lesson is live and the practice is targeted — and no, when it is a recorded video library marketed as tuition.\" The format matters far less than the execution.",
    "publishDate": "2026-02-09",
    "updatedDate": "2026-02-09",
    "reviewedDate": "2026-02-09",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for accuracy against PSLE syllabus structure and online live-instruction research",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against PSLE assessment guidelines, MOE syllabus, and the broader research base on K-12 synchronous online learning",
    "expertiseAreas": [
      "PSLE Preparation",
      "Online Learning",
      "Singapore Education",
      "Math Learning"
    ],
    "primaryCtaPath": "/online-psle-math-tuition",
    "primaryCtaLabel": "See online PSLE math tuition with DeepThink",
    "primaryCtaDescription": "Read the dedicated page for online PSLE math tuition for Primary 5 and Primary 6 students.",
    "readingTimeMinutes": 9,
    "category": "Primary Math",
    "audience": "parents-and-students",
    "tags": [
      "psle",
      "online-tuition",
      "online-learning",
      "singapore-tuition",
      "math-tuition",
      "primary-6"
    ],
    "contentFileName": "is-online-math-tuition-effective-for-psle.mdx"
  },
  {
    "slug": "math-skills-that-matter-after-school",
    "title": "The Math Skills That Matter After School — And Whether Singapore Education Builds Them",
    "description": "What mathematical thinking actually looks like in the real world — modeling, reasoning under uncertainty, abstraction, computational thinking — and where school math connects to that power (or doesn't).",
    "excerpt": "School math builds procedural fluency. The math that shapes the world is something else entirely. Here's what it actually is, and what parents should know.",
    "publishDate": "2025-05-05",
    "updatedDate": "2025-05-05",
    "reviewedDate": "2025-05-05",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for alignment with Singapore curriculum and real-world mathematical literacy research",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against Singapore Math curriculum, PISA research, and mathematical thinking literature",
    "expertiseAreas": [
      "Math Learning",
      "Learning Science",
      "Singapore Education",
      "Parent Guidance"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Talk to us about your child",
    "primaryCtaDescription": "Speak with our team about how we build genuine mathematical thinking, not just exam technique.",
    "readingTimeMinutes": 14,
    "category": "Learning & Mindset",
    "audience": "parents-and-students",
    "tags": [
      "math-learning",
      "singapore-education",
      "mathematical-thinking",
      "learning-science",
      "parent-guidance"
    ],
    "contentFileName": "math-skills-that-matter-after-school.mdx"
  },
  {
    "slug": "math-tuition-for-students-with-high-anxiety",
    "title": "Math Tuition for Students With High Anxiety — What Works Differently",
    "description": "Math anxiety is neurologically real, not a mindset problem. Here is what cognitive science and anxiety research tell us about how to teach math differently to high-anxiety students.",
    "excerpt": "If your child freezes during math tests despite knowing the material, the answer is a fundamentally different pedagogical approach — not just a warmer tutor.",
    "publishDate": "2025-12-11",
    "updatedDate": "2025-12-11",
    "reviewedDate": "2025-12-11",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for alignment with math anxiety research and Singapore tuition context",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against math anxiety literature and Singapore Primary and Secondary Math assessment demands",
    "expertiseAreas": [
      "Math Learning",
      "Learning Science",
      "Primary Math",
      "Secondary Math"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Talk to us about your child",
    "primaryCtaDescription": "Speak with our team about whether our approach is a fit for a student with math anxiety.",
    "readingTimeMinutes": 12,
    "category": "Learning & Mindset",
    "audience": "parents-and-students",
    "tags": [
      "math-anxiety",
      "math-learning",
      "learning-science",
      "psle",
      "o-level",
      "singapore-tuition"
    ],
    "contentFileName": "math-tuition-for-students-with-high-anxiety.mdx"
  },
  {
    "slug": "normal-academic-g2-pathways",
    "title": "My Child Is in Normal Academic (G2) — What Are Their Options?",
    "description": "A complete guide for parents of G2 Normal Academic students in Singapore — covering N-Level pathways, Sec 5 eligibility, direct poly admission, ITE, subject upgrading, and what G2 Math actually demands.",
    "excerpt": "Almost every tuition article is aimed at Express families. This guide is written specifically for G2 parents — with the real pathways, not the folklore.",
    "publishDate": "2025-07-04",
    "updatedDate": "2025-07-04",
    "reviewedDate": "2025-07-04",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for N(A) syllabus accuracy and Singapore secondary pathway guidance",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against current MOE N(A) Math syllabus (4045/4046) and post-N-Level pathway requirements",
    "expertiseAreas": [
      "Secondary Math",
      "N-Level",
      "Singapore Education",
      "Parent Guidance"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Talk to us about your G2 child",
    "primaryCtaDescription": "Speak with our team about N(A) Math support and how we prepare G2 students for their specific pathway.",
    "readingTimeMinutes": 14,
    "category": "Secondary Math",
    "audience": "parents-and-students",
    "tags": [
      "n-level",
      "normal-academic",
      "g2-stream",
      "secondary-math",
      "singapore-tuition",
      "poly-admission"
    ],
    "contentFileName": "normal-academic-g2-pathways.mdx"
  },
  {
    "slug": "normal-technical-g1-pathways",
    "title": "My Child Is in Normal Technical (G1) — What Are Their Options?",
    "description": "A complete guide for parents of Normal Technical (G1) students in Singapore — covering the N(T)/G1 curriculum, ITE entry, the Early Admissions Exercise, subject upgrading, the full progression ladder to poly and university, and what G1 Math actually demands.",
    "excerpt": "Most guidance for Singapore parents is written with the academic track in mind. This guide is written specifically for Normal Technical parents — with the real pathways, not the folklore.",
    "publishDate": "2026-06-29",
    "updatedDate": "2026-06-29",
    "reviewedDate": "2026-06-29",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for N(T)/G1 syllabus accuracy and Singapore post-secondary pathway guidance",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against the current MOE N(T) course pages, SEAB syllabus 4046, and ITE admission and progression documentation",
    "expertiseAreas": [
      "Secondary Math",
      "N-Level",
      "Singapore Education",
      "Parent Guidance"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Talk to us about your G1 child",
    "primaryCtaDescription": "Speak with our team about N(T)/G1 Math support and preparing your child for their specific pathway.",
    "readingTimeMinutes": 15,
    "category": "Secondary Math",
    "audience": "parents-and-students",
    "tags": [
      "n-level",
      "normal-technical",
      "g1-stream",
      "ite",
      "secondary-math",
      "singapore-tuition"
    ],
    "contentFileName": "normal-technical-g1-pathways.mdx"
  },
  {
    "slug": "online-math-tuition-singapore-busy-parent-guide",
    "title": "Online Math Tuition in Singapore — A Busy Parent's Guide to Choosing Well",
    "description": "A practical guide for time-pressed Singapore parents weighing online math tuition. Covers the honest case for and against, seven questions to ask any programme, red flags to avoid, what fair pricing looks like, and a five-minute decision checklist.",
    "excerpt": "If you are a working parent looking at online math tuition because in-person feels structurally impossible, this is written for you. Less time on commute does not have to mean less rigour on the math.",
    "publishDate": "2026-03-21",
    "updatedDate": "2026-03-21",
    "reviewedDate": "2026-03-21",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for online tuition operations and Singapore busy-parent decision context",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against Singapore tuition pricing benchmarks, lesson-format research, and parent decision frameworks",
    "expertiseAreas": [
      "Online Learning",
      "Singapore Tuition",
      "Parent Guidance",
      "Math Learning"
    ],
    "primaryCtaPath": "/online-math-tuition",
    "primaryCtaLabel": "See how DeepThink runs online math tuition",
    "primaryCtaDescription": "Read the pillar page on how DeepThink delivers live online math tuition for Singapore primary and secondary students.",
    "readingTimeMinutes": 11,
    "category": "Choosing Math Tuition",
    "audience": "parents-and-students",
    "tags": [
      "online-tuition",
      "singapore-tuition",
      "math-tuition",
      "parent-guidance",
      "busy-parents"
    ],
    "contentFileName": "online-math-tuition-singapore-busy-parent-guide.mdx"
  },
  {
    "slug": "polytechnic-vs-junior-college-after-o-levels",
    "title": "Polytechnic or Junior College After O-Levels? An Honest Decision Guide",
    "description": "A focused decision guide for O-Level students choosing between Junior College and Polytechnic — how admission actually works today (L1R5 and ELR2B2), what changes from 2028, and who each path actually suits.",
    "excerpt": "JC and poly get treated as a hierarchy — one a step down from the other — when they are actually two different systems built for different kinds of learning. Here is the decision, reframed properly.",
    "publishDate": "2026-05-30",
    "updatedDate": "2026-05-30",
    "reviewedDate": "2026-05-30",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for accuracy against current MOE JAE admission criteria, Ngee Ann and Temasek Polytechnics' admissions pages, and MOE's Full SBB / 2028 Post-Secondary Admissions Exercise guidance",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against MOE's JC, polytechnic, and Early Admissions Exercise pages, Ngee Ann Polytechnic's ELR2B2 guidance, and the current H2 Mathematics syllabus document",
    "expertiseAreas": [
      "Secondary Math",
      "Singapore Education",
      "Parent Guidance"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Talk to us about your child's O-Level Math",
    "primaryCtaDescription": "Speak with our team about A-Math, E-Math, and how either path shapes the Math your child needs next.",
    "readingTimeMinutes": 13,
    "category": "Secondary Math",
    "audience": "parents-and-students",
    "tags": [
      "polytechnic",
      "junior-college",
      "o-level",
      "jae",
      "secondary-admission",
      "moe"
    ],
    "contentFileName": "polytechnic-vs-junior-college-after-o-levels.mdx"
  },
  {
    "slug": "primary-math-word-problem-mistakes",
    "title": "4 Primary Math Word-Problem Mistakes and How to Fix Them",
    "description": "Learn the most common word-problem mistakes in Primary Math and practical routines that help students solve them with confidence.",
    "excerpt": "Many students lose marks on word problems not because they cannot calculate, but because they choose the wrong model or operation.",
    "publishDate": "2025-11-21",
    "updatedDate": "2025-11-21",
    "reviewedDate": "2025-11-21",
    "authorName": "DeepThink Academic Team",
    "authorType": "Organization",
    "authorRole": "Editorial team",
    "authorCredentials": "Reviewed for Primary Math clarity and exam alignment",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against Primary Math and PSLE preparation needs",
    "expertiseAreas": [
      "Primary Math",
      "Word Problems",
      "PSLE Preparation"
    ],
    "primaryCtaPath": "/primary-6",
    "primaryCtaLabel": "See Primary 6 Math tuition",
    "primaryCtaDescription": "Read the Primary 6 tuition page for PSLE-focused support, weekly classes, and trial details.",
    "readingTimeMinutes": 10,
    "category": "Primary Math",
    "audience": "parents-and-students",
    "tags": [
      "primary-math",
      "word-problems",
      "psle-prep",
      "problem-solving"
    ],
    "contentFileName": "primary-math-word-problem-mistakes.mdx"
  },
  {
    "slug": "should-my-child-take-a-math",
    "title": "Should My Child Take A-Math? The Honest Tradeoffs",
    "description": "The real costs of A-Math in Sec 3–4 time, which JC courses actually need it, what dropping it mid-stream looks like, and the specific student profile that tends to regret taking it.",
    "excerpt": "Every other article just lists career benefits. This one covers what A-Math actually costs — and who should think hard about opting out.",
    "publishDate": "2025-09-22",
    "updatedDate": "2025-09-22",
    "reviewedDate": "2025-09-22",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for O-Level A-Math and subject selection accuracy",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against current Singapore O-Level and JC subject requirements",
    "expertiseAreas": [
      "O-Level Math",
      "A-Math",
      "Subject Selection",
      "Secondary Math"
    ],
    "primaryCtaPath": "/o-level",
    "primaryCtaLabel": "See O-Level Math tuition options",
    "primaryCtaDescription": "Review our online small-group O-Level classes for E-Math and A-Math support.",
    "readingTimeMinutes": 12,
    "category": "Secondary Math",
    "audience": "parents-and-students",
    "tags": [
      "a-math",
      "o-level",
      "subject-selection",
      "secondary-math",
      "singapore-tuition"
    ],
    "contentFileName": "should-my-child-take-a-math.mdx"
  },
  {
    "slug": "sleep-and-math-performance",
    "title": "How Much Sleep Does a P6 or Sec 4 Student Actually Need — And What Happens to Math Performance Without It",
    "description": "Sleep deprivation creates a math performance penalty that extra revision cannot compensate for. Here is the neuroscience on how much sleep P6 and Sec 4 students need — and what to do about it.",
    "excerpt": "The two hours of sleep before an exam are worth more than the two hours of practice before sleeping.",
    "publishDate": "2025-07-24",
    "updatedDate": "2025-07-24",
    "reviewedDate": "2025-07-24",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for alignment with sleep science research and Singapore academic context",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against sleep medicine literature on memory consolidation and executive function in children and adolescents",
    "expertiseAreas": [
      "Math Learning",
      "Learning Science",
      "Primary Math",
      "Secondary Math"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Talk to us about your child",
    "primaryCtaDescription": "Speak with our team about how we structure sessions and timing to support how the brain actually learns.",
    "readingTimeMinutes": 12,
    "category": "Learning & Mindset",
    "audience": "parents-and-students",
    "tags": [
      "sleep",
      "math-learning",
      "learning-science",
      "psle",
      "o-level",
      "study-skills",
      "singapore-tuition"
    ],
    "contentFileName": "sleep-and-math-performance.mdx"
  },
  {
    "slug": "weekly-math-revision-routine",
    "title": "How to Build a Weekly Math Revision Routine That Sticks",
    "description": "Use a simple weekly structure to keep Math revision consistent, focused, and easier to sustain during a busy school term.",
    "excerpt": "A revision routine works best when students know what to do each day and can keep sessions short but consistent.",
    "publishDate": "2025-10-12",
    "updatedDate": "2025-10-12",
    "reviewedDate": "2025-10-12",
    "authorName": "DeepThink Academic Team",
    "authorType": "Organization",
    "authorRole": "Editorial team",
    "authorCredentials": "Reviewed for weekly revision practicality",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against Secondary Math revision needs",
    "expertiseAreas": [
      "Secondary Math",
      "Revision Planning",
      "Exam Preparation"
    ],
    "primaryCtaPath": "/sec-3",
    "primaryCtaLabel": "See Secondary 3 Math tuition",
    "primaryCtaDescription": "Read the Secondary 3 tuition page for stream-specific support and exam preparation.",
    "readingTimeMinutes": 7,
    "category": "Learning & Mindset",
    "audience": "parents-and-students",
    "tags": [
      "study-routine",
      "revision-planning",
      "secondary-math",
      "exam-prep"
    ],
    "contentFileName": "weekly-math-revision-routine.mdx"
  },
  {
    "slug": "what-good-o-level-math-revision-looks-like",
    "title": "What Good O-Level Math Revision Looks Like (vs What Most Students Actually Do)",
    "description": "Most O-Level Math revision produces students who can follow worked solutions but struggle with unfamiliar questions. Here is what effective revision actually looks like — for both E-Math and A-Math.",
    "excerpt": "If the grades aren't moving despite genuine effort, the method is almost certainly the problem — not the hours.",
    "publishDate": "2026-04-10",
    "updatedDate": "2026-04-10",
    "reviewedDate": "2026-04-10",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for O-Level E-Math and A-Math classroom relevance",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against current Singapore O-Level E-Math and A-Math assessment demands",
    "expertiseAreas": [
      "O-Level Math",
      "Exam Strategy",
      "A-Math",
      "E-Math"
    ],
    "primaryCtaPath": "/o-level",
    "primaryCtaLabel": "See O-Level Math tuition options",
    "primaryCtaDescription": "Review our online small-group O-Level classes for E-Math and A-Math support.",
    "readingTimeMinutes": 12,
    "category": "Secondary Math",
    "audience": "parents-and-students",
    "tags": [
      "o-level",
      "revision",
      "e-math",
      "a-math",
      "exam-prep"
    ],
    "contentFileName": "what-good-o-level-math-revision-looks-like.mdx"
  },
  {
    "slug": "what-good-psle-math-revision-looks-like",
    "title": "What Good PSLE Math Revision Looks Like (vs What Most Students Actually Do)",
    "description": "Most PSLE Math revision produces little because it lacks retrieval, struggle, and error investigation. Here is what effective revision actually looks like.",
    "excerpt": "If your child is putting in hours but results aren't moving, the method is almost certainly the problem — not the effort.",
    "publishDate": "2026-04-30",
    "updatedDate": "2026-04-30",
    "reviewedDate": "2026-04-30",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for PSLE Math revision effectiveness and P6 classroom relevance",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against current Singapore Primary Math assessment demands and PSLE exam format",
    "expertiseAreas": [
      "Primary Math",
      "PSLE Preparation",
      "Exam Strategy"
    ],
    "primaryCtaPath": "/primary-6",
    "primaryCtaLabel": "See Primary 6 Math tuition",
    "primaryCtaDescription": "Read the Primary 6 tuition page for PSLE-focused support, weekly classes, and trial details.",
    "readingTimeMinutes": 13,
    "category": "Primary Math",
    "audience": "parents-and-students",
    "tags": [
      "psle",
      "psle-prep",
      "revision",
      "primary-math",
      "exam-prep"
    ],
    "contentFileName": "what-good-psle-math-revision-looks-like.mdx"
  },
  {
    "slug": "what-the-data-says-about-tuition-in-singapore",
    "title": "What the Data Actually Says About Tuition in Singapore — A Review of the Research",
    "description": "A genuine literature review of the academic and policy research on private tuition in Singapore — what it actually does and does not show about grades, wellbeing, and who benefits.",
    "excerpt": "The research is more complicated, more limited, and more surprising than most parents — or most tuition centres — acknowledge.",
    "publishDate": "2025-05-25",
    "updatedDate": "2025-05-28",
    "reviewedDate": "2025-05-28",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for accuracy against academic literature and Singapore education policy documents",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against SingStat Household Expenditure Survey data, MOE policy documents, OECD PISA reports, NIE and UNESCO research, and peer-reviewed education journals",
    "expertiseAreas": [
      "Math Learning",
      "Learning Science",
      "Singapore Education",
      "Parent Guidance"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Talk to us about your child",
    "primaryCtaDescription": "Speak with our team about whether tuition makes sense for your child's specific situation.",
    "readingTimeMinutes": 15,
    "category": "Choosing Math Tuition",
    "audience": "parents-and-students",
    "tags": [
      "tuition",
      "singapore-tuition",
      "education-research",
      "psle",
      "o-level",
      "learning-science"
    ],
    "contentFileName": "what-the-data-says-about-tuition-in-singapore.mdx"
  },
  {
    "slug": "what-the-research-says-about-math-anxiety",
    "title": "What the Research Actually Says About Math Anxiety",
    "description": "A genuine literature review of the science of math anxiety — what it is, how it interferes with performance, whether it causes poor grades or the reverse, how it is passed on, and what the evidence says actually helps.",
    "excerpt": "Math anxiety is real, measurable, and more complicated than either \"just calm down\" or \"she's not a maths person\" makes it sound. Here is what the research shows — and what it doesn't.",
    "publishDate": "2026-07-19",
    "updatedDate": "2026-07-19",
    "reviewedDate": "2026-07-19",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for accuracy against the peer-reviewed math-anxiety and education-psychology literature",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against PISA/OECD data, Psychological Bulletin meta-analyses, and the primary math-anxiety research literature",
    "expertiseAreas": [
      "Learning Science",
      "Math Learning",
      "Parent Guidance",
      "Singapore Education"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Talk to us about your child",
    "primaryCtaDescription": "Speak with our team about a child who has grown anxious about maths and what would actually help.",
    "readingTimeMinutes": 17,
    "category": "Learning & Mindset",
    "audience": "parents-and-students",
    "tags": [
      "math-anxiety",
      "learning-science",
      "wellbeing",
      "education-research",
      "parent-guidance"
    ],
    "contentFileName": "what-the-research-says-about-math-anxiety.mdx"
  },
  {
    "slug": "when-to-start-o-level-math-preparation",
    "title": "When Should You Start O-Level Math Preparation?",
    "description": "A realistic timeline for O-Level Math preparation, including what to focus on in each phase before final exams.",
    "excerpt": "Strong O-Level preparation starts earlier than most students expect, but it does not need to feel overwhelming.",
    "publishDate": "2026-01-20",
    "updatedDate": "2026-01-20",
    "reviewedDate": "2026-01-20",
    "authorName": "DeepThink Academic Team",
    "authorType": "Organization",
    "authorRole": "Editorial team",
    "authorCredentials": "Reviewed for O-Level timing and exam readiness",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against O-Level exam-preparation milestones",
    "expertiseAreas": [
      "O-Level Math",
      "Revision Planning",
      "Exam Preparation"
    ],
    "primaryCtaPath": "/o-level",
    "primaryCtaLabel": "See O-Level Math tuition",
    "primaryCtaDescription": "Read the O-Level page for E-Math and A-Math support, weekly classes, and trial details.",
    "readingTimeMinutes": 7,
    "category": "Secondary Math",
    "audience": "secondary-students",
    "tags": [
      "o-level",
      "exam-prep",
      "revision-planning",
      "secondary-math"
    ],
    "contentFileName": "when-to-start-o-level-math-preparation.mdx"
  },
  {
    "slug": "why-struggling-with-math-beats-getting-the-right-answer",
    "title": "Why Learning to Struggle With Math Is More Valuable Than Getting the Right Answer",
    "description": "The productive failure research — conducted in Singapore schools — shows that struggling before instruction produces deeper learning than guided correction. Here is what that means for tuition.",
    "excerpt": "That moment of smooth, guided correction might be one of the least effective things that can happen to a child who is trying to learn mathematics.",
    "publishDate": "2025-09-02",
    "updatedDate": "2025-09-02",
    "reviewedDate": "2025-09-02",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for alignment with productive failure research and Singapore tuition context",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against Kapur productive failure literature and Singapore Primary and Secondary Math assessment demands",
    "expertiseAreas": [
      "Math Learning",
      "Learning Science",
      "Primary Math",
      "Secondary Math"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Talk to us about how we teach",
    "primaryCtaDescription": "Ask our team how we structure sessions to build genuine understanding, not just correct answers.",
    "readingTimeMinutes": 10,
    "category": "Learning & Mindset",
    "audience": "parents-and-students",
    "tags": [
      "math-learning",
      "productive-failure",
      "learning-science",
      "psle",
      "o-level",
      "singapore-tuition"
    ],
    "contentFileName": "why-struggling-with-math-beats-getting-the-right-answer.mdx"
  },
  {
    "slug": "why-your-child-keeps-losing-marks-in-math",
    "title": "Why Your Child Keeps Losing Marks in Math (And It's Not Carelessness)",
    "description": "Most repeated Math mark loss follows four root causes—concept, procedure, reading, and pressure gaps—with a different fix for each.",
    "excerpt": "If the same \"careless\" mistake keeps happening, it is a pattern signal that can be fixed with targeted teaching and practice.",
    "publishDate": "2026-03-01",
    "updatedDate": "2026-03-01",
    "reviewedDate": "2026-03-01",
    "authorName": "DeepThink Teaching Team",
    "authorType": "Organization",
    "authorRole": "Teaching team",
    "authorCredentials": "Reviewed for PSLE and O-Level classroom relevance",
    "reviewerName": "DeepThink Academic Team",
    "reviewerType": "Organization",
    "reviewerRole": "Curriculum review",
    "reviewerCredentials": "Checked against common Singapore Primary and Secondary Math assessment patterns",
    "expertiseAreas": [
      "Primary Math",
      "Secondary Math",
      "Exam Strategy"
    ],
    "primaryCtaPath": "/contact",
    "primaryCtaLabel": "Book a Math diagnostic consult",
    "primaryCtaDescription": "Speak with our team to identify your child's root cause and get a targeted plan.",
    "readingTimeMinutes": 12,
    "category": "Learning & Mindset",
    "audience": "parents-and-students",
    "tags": [
      "careless-mistakes",
      "math-learning",
      "psle",
      "o-level"
    ],
    "contentFileName": "why-your-child-keeps-losing-marks-in-math.mdx"
  }
];
